import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: "AIzaSyCircQ052liTGXU7joXGfIdlbokcE-EkwM",
  authDomain: "jbarquinha-28a41.firebaseapp.com",
  projectId: "jbarquinha-28a41",
  storageBucket: "jbarquinha-28a41.appspot.com",
  messagingSenderId: "669766058659",
  appId: "1:669766058659:web:5938d7ae1a0cf7f978f516",
  measurementId: "G-6916F0L383"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

const askAiViaPhp = async (messages) => {
  const user = auth.currentUser;
  if (!user) {
    throw new Error("Not signed in");
  }

  const token = await user.getIdToken();
  const response = await fetch("/admin-ai.php", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ messages }),
  });

  const payload = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(payload.error || "AI request failed");
  }

  return payload.content || "";
};

const askAiLocal = async (messages) => {
  const response = await fetch("https://api.openai.com/v1/chat/completions", {
    method: "POST",
    headers: {
      Authorization: `Bearer ${process.env.REACT_APP_OPENAI_KEY || ""}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      model: "gpt-4.1-mini",
      messages,
      temperature: 0.3,
    }),
  });

  const payload = await response.json();
  if (!response.ok) {
    throw new Error(payload.error?.message || "AI request failed");
  }

  return payload.choices?.[0]?.message?.content || "";
};

export const askAi = async (messages) => {
  const host = window.location.hostname;
  const isLocal = host === "localhost" || host === "127.0.0.1";

  if (isLocal && process.env.NODE_ENV !== "production") {
    try {
      return await askAiLocal(messages);
    } catch (error) {
      return askAiViaPhp(messages);
    }
  }

  return askAiViaPhp(messages);
};

export { auth, db, storage };
